<!--
 * @Description: 自定义规则设置
 * @Author: huzhibo
 * @Email: hzbfun@gmail.com
 * @Date: 2020/11/9 15:11
 -->
<template>
  <el-dialog
    :title="`${customLabel}计费依据自定义设置`"
    width="1000px"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="custom-rules-dialog billing-rules-style__wrapper"
  >
    <el-form :model="fee" label-width="80px" ref="customRulesForm">
      <!--计费项-->
      <div
        v-for="(item, idx) in fee.gist"
        :key="gistOwnKey.get(item)"
        class="gist-row"
      >
        <!--规则标题-->
        <h3 class="fee-rule-title rule-title">
          <span class="rule-title-idx">{{ idx + 1 }}</span>
          <i
            v-if="deleteBtnVisible"
            @click="handleDeleteRule(idx)"
            class="e6-icon-clear_line rule-title-delete"
          ></i>
        </h3>
        <el-form-item
          class=""
          label="条件"
          :prop="`gist[${idx}].condition`"
          :rules="validateRules.condition"
        >
          <!--条件设置-->
          <condition-setting
            :ref="`condition-${idx}`"
            :conditionType="item.conditionType"
            :conditions="item.conditions"
          />
        </el-form-item>
        <el-form-item
          :label="`${customLabel}等于`"
          :prop="`gist[${idx}].value`"
          :rules="validateRules.value"
        >
          <expression v-model="item.value" />
        </el-form-item>
      </div>
      <!--添加按钮-->
      <div class="btn-group-rule">
        <span @click="handleAddRules"
          ><i class="e6-icon-add_line"></i>添加规则</span
        >
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button class="cancel" @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSave"> 确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// components
import conditionSetting from "./puppet/conditionSetting";
import expression from "./puppet/expression";

export default {
  name: "customRules",
  components: { conditionSetting, expression },

  data() {
    return {
      dialogVisible: false,
      successCb: null,
      fee: {
        standard: "",
        gist: []
      },
      // 检验规则
      validateRules: {
        value: { required: true, message: "不能为空" },
        condition: { validator: this.conditionValidator }
      },
      gistOwnKey: new WeakMap(),
      deleteBtnVisible: false
    };
  },

  watch: {
    "fee.gist"(gist) {
      const { gistOwnKey } = this;

      // 初始化费用设置数据
      if (!gist.length)
        this.fee.gist = [
          {
            conditionType: "1", // 条件类型
            conditions: [],
            value: "" // 自定义计费依据的计算方法
          }
        ];

      // 初始化key
      Array.isArray(gist) &&
        gist.forEach(
          v => !gistOwnKey.has(v) && gistOwnKey.set(v, Math.random())
        );

      // 设置是否显示删除按钮
      this.deleteBtnVisible = gist.length > 1;
    }
  },

  computed: {
    // 自定义设置的类型
    customLabel() {
      switch (this.fee.standard) {
        case "1": // 数量
          return "数量";
        case "2": // 重量
        case "5": // 吨公里
          return "重量";
        case "3": // 体积
        case "6": // 立方公里
          return "体积";
        default:
          return "";
      }
    }
  },

  methods: {
    show(fee, cb) {
      if (!fee) return;

      this.fee = _.cloneDeep(fee);
      this.successCb = cb;
      // 显示弹窗
      this.dialogVisible = true;
    },

    // 校验规则
    conditionValidator(rules, value, cb) {
      const matchRes = rules.field.match(/gist\[(\d)+].condition/);

      // 不匹配则校验成功
      if (!matchRes) return cb();

      // 找到表单的引用
      let fieldRef = this.$refs[`condition-${matchRes[1]}`];
      if (Array.isArray(fieldRef)) fieldRef = fieldRef[0];
      // 没找到则校验成功
      if (!fieldRef) return cb();
      // 调用校验方法
      fieldRef.validate(valid => (valid ? cb() : cb("")));
    },

    // 添加规则
    handleAddRules() {
      this.fee.gist.push({
        conditionType: "1", // 条件类型
        conditions: [],
        value: "" // 自定义计费依据的计算方法
      });
    },

    // 删除规则
    handleDeleteRule(idx) {
      this.fee.gist.splice(idx, 1);
    },

    // 保存事件
    handleSave() {
      const { successCb, fee, handleClose } = this;

      this.$refs.customRulesForm.validate(valid => {
        if (!valid) return;
        typeof successCb === "function" && successCb(fee);
        handleClose();
      });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.fee = {
        gist: []
      };
    }
  }
};
</script>

<style lang="scss">
@import "~e6-module-settle-accounts-center/assets/styles/billingRule.scss";
</style>
